// Namespace формы обращения в поддержку.
//
// Словарь регистрирует `lib/i18n.ts` обходом каталога `locales/` — здесь
// только точка доступа, как у остальных разделов входа.
import { useTranslation } from "react-i18next";

export const SUPPORT_NS = "support";

export function useSupportT() {
	return useTranslation(SUPPORT_NS).t;
}
